export const MIN_SCREEN_WIDTH = 1366;
export const WHOLESALER_TO_UPDATE = 'ABC';
